export const TAGS_FETCH_QTY = 40;